import ReactSwitch from 'react-switch';
import { Checkbox, Row, Text } from '~/commonComponents';
import { Links } from '~/constants';
import { TnCOffices } from '~/constants/ff.posthog';
import { OfficeTnCTypeEnum, useGetPublicConsent } from '~/domain/Consents';
import { useFeatureFlag } from '~/hooks/useFeatureFlag';
import { useTrackEvent } from '~/hooks/useTrackEvent';
import { POSTHOG_EVENTS } from '~/services/posthog';
import { Colors } from '~/themes/colors';
import { SignUpTermsAndConditions } from './SignUpTermsAndConditions';
import { useState } from 'react';
import { Modal } from 'react-bootstrap';

interface IAcceptTermsV2Props {
  value: boolean;
  onChange: (value: boolean) => void;
  isError?: boolean;
  consent?: OfficeTnCTypeEnum;
}

export const AcceptTerms = ({
  value,
  onChange,
  isError,
  consent = OfficeTnCTypeEnum.OFFICE_TNC,
}: IAcceptTermsV2Props) => {
  const isFeatureEnabled = useFeatureFlag(TnCOffices);
  const trackEvent = useTrackEvent();
  const [showTnc, setShowTnc] = useState(false);
  const { data, isLoading } = useGetPublicConsent(
    { consent },
    { enable: isFeatureEnabled }
  );

  const pdfUrl = data?.notConsentedRequirements?.[0]?.url;

  if (isLoading) {
    return (
      <Row width="100%">
        {/* <Skeleton width={400} height={40} skeletonStyle={{ borderRadius: 6, flex: 1 }} /> */}
      </Row>
    );
  }

  if (!isFeatureEnabled || !pdfUrl) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          columnGap: 15,
          marginTop: 35,
        }}
      >
        <ReactSwitch
          checked={value}
          onChange={() => onChange(!value)}
          onColor={Colors.secondary_500}
          onHandleColor="#fff"
          handleDiameter={20}
          uncheckedIcon={false}
          checkedIcon={false}
          offColor={Colors.neutral_100}
          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.35)"
          activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
          height={25}
          width={50}
          className="react-switch"
          id="material-switch"
          data-cy="input-switch-tnc"
        />

        <p
          className="global_font"
          style={{ margin: 0, color: Colors.neutral_600 }}
        >
          Agree to{' '}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={Links.termsOfUse}
            className="title_font"
            style={{
              color: Colors.secondary_500,
              textDecoration: 'none',
              fontSize: 16,
            }}
            data-cy="term-and-conditions-link"
          >
            Terms and Conditions
          </a>
        </p>
      </div>
    );
  }

  const handlePress = () => {
    if (value) {
      onChange(false);

      return;
    }

    trackEvent(POSTHOG_EVENTS.DENTAL_PORTAL_TERMS_POPUP_VIEWED, { source: 'signup' });
    setShowTnc(true);
  };

  return (
    <>
      <div onClick={handlePress} style={{ width: '100%', cursor: 'pointer' }} data-cy="accept-tnc-row">
        <Row
          backgroundColor={Colors.secondary_50}
          borderRadius={6}
          height={40}
          alignItems="center"
          paddingLeft={14}
          style={
            isError
              ? {
                  borderWidth: 1.5,
                  borderColor: Colors.error_500,
                  borderRadius: 16,
                  padding: 2,
                  margin: -2,
                }
              : {}
          }
        >
          <Checkbox checked={value} />
          <div
            style={{
              width: 1,
              height: 24,
              backgroundColor: Colors.neutral_400,
              marginLeft: 10,
            }}
          />
          <Text fontSize={16} bold color="primary_500" marginLeft={10}>
            Agree to Terms and Conditions
          </Text>
        </Row>
      </div>
      {showTnc && (
        <Modal show={showTnc} data-cy="tnc-modal">
          <SignUpTermsAndConditions
            pdfUrl={pdfUrl}
            handleAccept={() => {
              trackEvent(POSTHOG_EVENTS.DENTAL_PORTAL_TERMS_POPUP_ACCEPTED, { source: 'signup' });
              onChange(true);
              setShowTnc(false);
            }}
            isLoading={isLoading}
          />
        </Modal>
      )}
    </>
  );
};
